import React from 'react'
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ExpenseFlexiReportsChild from "./ExpenseFlexiReportsChild";

const ExpenseFlexiReports = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ExpenseFlexiReportsChild />
      </CardBackground>
    </MainTemplate>
  )
}

export default ExpenseFlexiReports